import React, { memo } from 'react';
import Section from 'kepler/lib/components/Section';
import Row from 'kepler/lib/components/Row';
import Col from 'kepler/lib/components/Col';
import getContent from '../lib/dictionaryFetcher';

const Banner = memo(() => {
  return (
    <div id="myapps-banner">
      <Section className="Apps-toolsBanner">
        <Row>
          <Col className={'Apps-welcome'}>
            <div className="Apps-message">
              <h1>{getContent('merchanthub', 'apps.banner.title')}</h1>
              <p>{getContent('merchanthub', 'apps.banner.subtitle')}</p>
            </div>
          </Col>
        </Row>
      </Section>
    </div>
  );
});

export default Banner;
